var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',{attrs:{"fluid":""}},[_c('Header'),_c('Admintopbar',{attrs:{"breadcrumb":_vm.breadcrumb}}),_c('section',{staticClass:"mt-3"},[_c('mdb-row',[_c('mdb-col',{attrs:{"md":"12"}},[_c('task-queue-form',{attrs:{"reload":_vm.reload,"error-prop":_vm.error,"submitting":_vm.submitting},on:{"submit":_vm.submit}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }